export const controllerClassNameSuffix = 'Controller';
